export default __webpack_public_path__ + "static/media/Artboard 1.89f77a3f.jpg";